import { useQuery } from "react-query"
import { list_invtiations } from "../../services/admin";


const useInvitations = (page, filter) => {
    return useQuery(['get_invitations', page], ()=>list_invtiations(page))
}

export default useInvitations;